import React from 'react';
import style from './style.module.scss';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {OnlyDesktop} from 'components/OnlyDesktop';
import ExpertShield from 'components/Shield/Expert/ExpertShield';
import {formatRating} from 'core/helpers';
import {OnlyMobile} from 'components/OnlyMobile';
import {Tooltip} from 'components/Tooltip';
import {Typography} from 'components/Typography';

type TExpertRatingProps = IProductSnippet['ratings'][0];

export const ExpertRating = (props: TExpertRatingProps) => {
    const {code, title, value} = props;

    if (code.toLowerCase() === title.toLowerCase()) {
        return (
            <React.Fragment key={code}>
                <OnlyDesktop>
                    <ExpertShield size={'medium'}>
                        {code} {formatRating(value)}
                    </ExpertShield>
                </OnlyDesktop>
                <OnlyMobile>
                    <ExpertShield size={'small'}>
                        {code} {formatRating(value)}
                    </ExpertShield>
                </OnlyMobile>
            </React.Fragment>
        );
    }

    return (
        <Tooltip
            key={code}
            childrenClassName={style.tooltip}
            overlay={
                <Typography className={style.overlay} variant={'label-12-r'}>
                    {title}
                </Typography>
            }
            place={'bottom'}
        >
            <ExpertShield key={code} size={'small'}>
                {code} {formatRating(value)}
            </ExpertShield>
        </Tooltip>
    );
};
